module.exports = {"TXTCLI_Description":{"id":"TXTCLI_Description","defaultMessage":"Περιγραφή"}}